import { StyleSheet } from '@react-pdf/renderer';

// La libranza es una sola hoja: membrete, autorización, firmas y el espacio de
// la entidad pagadora. El impreso usa una tipografía de palo seco y aprovecha
// casi todo el alto útil, así que los tamaños y márgenes de aquí están ajustados
// para que el bloque de la pagadora no se pase a una segunda página.
export const COLORS = {
    texto: '#000000',
    linea: '#000000',
    suave: '#5A5A5A',
};

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 8.2,
        lineHeight: 1.3,
        color: COLORS.texto,
        paddingTop: 24,
        paddingBottom: 20,
        paddingHorizontal: 40,
    },

    // ---- Membrete ----
    header: {
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    logo: {
        width: 152,
    },
    membrete: {
        flex: 1,
        paddingLeft: 18,
        paddingTop: 10,
    },
    membreteLinea: {
        fontSize: 6.8,
        lineHeight: 1.35,
    },
    membreteFuerte: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 6.8,
        lineHeight: 1.35,
    },
    numeroRow: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        marginTop: -6,
        marginBottom: 10,
    },
    numeroTitulo: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 11,
    },
    numeroValor: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 9,
        width: 150,
        textAlign: 'center',
        borderBottomWidth: 0.8,
        borderColor: COLORS.linea,
        marginLeft: 4,
    },

    // ---- Monto y fecha ----
    encabezadoDatos: {
        flexDirection: 'row',
        marginBottom: 8,
    },
    etiqueta: {
        fontFamily: 'Helvetica-Bold',
    },
    lineaValor: {
        borderBottomWidth: 0.8,
        borderColor: COLORS.linea,
        paddingHorizontal: 3,
        paddingBottom: 1,
    },

    // ---- Cuerpo ----
    parrafo: {
        textAlign: 'justify',
        marginBottom: 5,
    },
    fuerte: {
        fontFamily: 'Helvetica-Bold',
    },
    subrayado: {
        textDecoration: 'underline',
    },
    // Los datos del crédito van en negrita dentro del párrafo corrido, que es
    // como quedan al diligenciar el formato a mano sobre la línea.
    dato: {
        fontFamily: 'Helvetica-Bold',
    },
    atentamente: {
        marginTop: 2,
        marginBottom: 14,
    },

    // ---- Firmas ----
    firmasRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    firmaCol: {
        flexDirection: 'row',
        width: '48%',
    },
    firmaDatos: {
        flex: 1,
    },
    firmaLinea: {
        borderTopWidth: 0.8,
        borderColor: COLORS.linea,
        paddingTop: 2,
    },
    firmaRol: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 8,
        marginBottom: 3,
    },
    firmaCampo: {
        flexDirection: 'row',
        marginBottom: 2,
    },
    firmaEtiqueta: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 7.5,
        width: 48,
    },
    firmaValor: {
        flex: 1,
        fontSize: 7.5,
        borderBottomWidth: 0.6,
        borderColor: COLORS.linea,
        paddingLeft: 2,
        paddingBottom: 1,
    },
    huella: {
        width: 46,
        height: 64,
        marginLeft: 6,
        marginTop: 2,
        borderWidth: 0.8,
        borderColor: COLORS.linea,
        borderRadius: 6,
    },

    // ---- Espacio de la entidad pagadora ----
    bannerPagadora: {
        borderWidth: 0.8,
        borderColor: COLORS.linea,
        paddingVertical: 3,
        marginTop: 10,
        marginBottom: 8,
    },
    bannerTexto: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 8.5,
        textAlign: 'center',
    },
    funcionarioRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 12,
    },
    funcionarioCol: {
        width: '52%',
    },
    selloCol: {
        width: '42%',
        alignItems: 'center',
    },
    sello: {
        width: '100%',
        height: 52,
        borderWidth: 0.8,
        borderColor: COLORS.linea,
        borderRadius: 6,
        marginBottom: 3,
    },
    selloTexto: {
        fontFamily: 'Helvetica-Bold',
        fontSize: 8,
    },
});

export default styles;
